import MessageSidebar from "./MessageSidebar";
import ComposeMail from "./ComposeMail";
import ComposeSMS from "./ComposeSms";
import AddCustomer from "./AddCustomer";
import MessageHistory from "./MessageHistory";
import Navbar from "../Navbar";
import Footer from "../Footer";
import MessageTemplate from "./MessageTemplate";
import CustomerList from "./CustomerList";
import SyncCustomer from "./SyncCustomer";
import { Route, Routes } from "react-router-dom";

export default function SendMessageLayout() {

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />

            <div className="flex-grow p-6 bg-gray-50">
                <div className="max-w-full grid grid-cols-12 gap-6 mx-20">

                    {/* Sidebar is always visible */}
                    <div className="col-span-3">
                        <MessageSidebar />
                    </div>

                    {/* Route rendering */}
                    <div className="col-span-9">
                        <Routes>
                            <Route
                                path="history"
                                element={<MessageHistory />}
                            />
                            <Route
                                path="compose-mail"
                                element={<ComposeMail />}
                            />
                            <Route
                                path="compose-sms"
                                element={<ComposeSMS />}
                            />
                            <Route
                                path="customer-list"
                                element={<CustomerList />}
                            />
                            <Route path="sync-customer" element={<SyncCustomer />} />
                            <Route path="add-customer" element={<AddCustomer />} />
                            <Route path="templates" element={<MessageTemplate />} />

                            <Route index element={<MessageHistory />} />
                        </Routes>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
